// Two-stage bootstrap: fetch the deployment's runtime config (/config.json)
// before the app module - and everything it imports - is evaluated, so all
// consumers see the final URLs. See Shield.UI.CommonVue/ClientApp/runtime-config.js.
import { loadRuntimeConfig } from 'common/runtime-config';

loadRuntimeConfig().then(() => import(/* webpackChunkName: "app-main" */ './app'));
